// extracted by css-extract-rspack-plugin
export default {"officesSelectBox":"OfficesSelectBox__officesSelectBox--sM4cF"};